<main class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <section hlmCard aria-labelledby="partner-login-title">
      <div hlmCardHeader>
        @switch (mode()) {
          @case ('login') {
            <h1 hlmCardTitle id="partner-login-title">Partnerbereich</h1>
            <p hlmCardDescription>
              Melde dich an, um deine Kunden zu sehen und ihre Schenkwerk-Konten zu betreuen.
            </p>
          }
          @case ('link') {
            <h1 hlmCardTitle id="partner-login-title">Neues Passwort festlegen</h1>
            <p hlmCardDescription>
              Gib die E-Mail-Adresse ein, mit der du dich als Partner angemeldet hast. Wir schicken
              dir einen Link, mit dem du ein neues Passwort festlegst.
            </p>
          }
          @case ('sent') {
            <h1 hlmCardTitle id="partner-login-title">Schau in dein Postfach</h1>
          }
        }
      </div>

      <div hlmCardContent class="space-y-6">
        @switch (mode()) {
          @case ('login') {
            <form
              [formGroup]="loginForm"
              (ngSubmit)="login()"
              class="flex flex-col gap-6"
              novalidate>
              <div hlmField>
                <label hlmFieldLabel for="partner-email">E-Mail</label>
                <input
                  hlmInput
                  id="partner-email"
                  type="email"
                  inputmode="email"
                  formControlName="email"
                  autocomplete="email"
                  placeholder="name@agentur.de"
                  class="w-full"
                  [attr.aria-invalid]="invalid('login', 'email') ? 'true' : null" />
                @if (invalid('login', 'email')) {
                  <p hlmFieldDescription class="text-destructive">
                    Bitte gib eine gültige E-Mail-Adresse ein
                  </p>
                }
              </div>

              <div hlmField>
                <label hlmFieldLabel for="partner-password">Passwort</label>
                <hlm-input-group class="w-full">
                  <input
                    hlmInputGroupInput
                    id="partner-password"
                    [type]="showPassword() ? 'text' : 'password'"
                    formControlName="password"
                    autocomplete="current-password"
                    [attr.aria-invalid]="invalid('login', 'password') ? 'true' : null" />
                  <hlm-input-group-addon align="inline-end">
                    <button
                      hlmInputGroupButton
                      type="button"
                      [attr.aria-label]="
                        showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'
                      "
                      (click)="showPassword.set(!showPassword())">
                      <ng-icon [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                    </button>
                  </hlm-input-group-addon>
                </hlm-input-group>
                @if (invalid('login', 'password')) {
                  <p hlmFieldDescription class="text-destructive">Passwort ist erforderlich</p>
                }
              </div>

              @if (error()) {
                <div hlmAlert variant="destructive" role="alert">
                  <ng-icon name="lucideTriangleAlert" />
                  <p hlmAlertTitle>{{ error() }}</p>
                  @if (unverifiedEmail()) {
                    <p hlmAlertDescription>
                      @if (verificationResent()) {
                        Wir haben dir den Bestätigungslink noch einmal geschickt.
                      } @else {
                        <button
                          type="button"
                          class="underline underline-offset-4"
                          (click)="resendVerification()">
                          Bestätigungslink erneut senden
                        </button>
                      }
                    </p>
                  } @else if (noGooglePartner()) {
                    <p hlmAlertDescription>
                      <a routerLink="/partner" class="underline underline-offset-4"
                        >Jetzt als Partner registrieren</a
                      >
                    </p>
                  }
                </div>
              }

              <button
                hlmBtn
                type="submit"
                class="w-full"
                [disabled]="loading()"
                [attr.aria-busy]="loading()">
                @if (loading()) {
                  <hlm-spinner />
                  Anmelden…
                } @else {
                  Anmelden
                }
              </button>
            </form>
            <app-google-button text="signin_with" (credential)="onGoogle($event)" />
            <p class="text-center text-sm">
              Passwort vergessen?
              <button type="button" class="underline underline-offset-4" (click)="show('link')">
                Link anfordern
              </button>
            </p>
            <p class="text-center text-sm">
              Noch kein Partner?
              <a routerLink="/partner" class="underline underline-offset-4">Jetzt registrieren</a>
            </p>
          }
          @case ('link') {
            <form
              [formGroup]="linkForm"
              (ngSubmit)="requestLink()"
              class="flex flex-col gap-6"
              novalidate>
              <div hlmField>
                <label hlmFieldLabel for="partner-link-email">E-Mail</label>
                <input
                  hlmInput
                  id="partner-link-email"
                  type="email"
                  inputmode="email"
                  formControlName="email"
                  autocomplete="email"
                  placeholder="name@agentur.de"
                  class="w-full"
                  [attr.aria-invalid]="invalid('link', 'email') ? 'true' : null" />
                @if (invalid('link', 'email')) {
                  <p hlmFieldDescription class="text-destructive">
                    Bitte gib eine gültige E-Mail-Adresse ein
                  </p>
                }
              </div>

              @if (error()) {
                <div hlmAlert variant="destructive" role="alert">
                  <ng-icon name="lucideTriangleAlert" />
                  <p hlmAlertTitle>{{ error() }}</p>
                </div>
              }

              <button
                hlmBtn
                type="submit"
                class="w-full"
                [disabled]="loading()"
                [attr.aria-busy]="loading()">
                @if (loading()) {
                  <hlm-spinner />
                  Wird gesendet…
                } @else {
                  Link schicken
                }
              </button>
            </form>
            <p class="text-center text-sm">
              <button type="button" class="underline underline-offset-4" (click)="show('login')">
                Zurück zur Anmeldung
              </button>
            </p>
          }
          @case ('sent') {
            <div hlmAlert role="status">
              <ng-icon name="lucideMail" />
              <p hlmAlertTitle>E-Mail ist unterwegs</p>
              <p hlmAlertDescription>{{ sentMessage() }}</p>
            </div>
            <p class="text-center text-sm">
              <button type="button" class="underline underline-offset-4" (click)="show('login')">
                Zurück zur Anmeldung
              </button>
            </p>
          }
        }
      </div>
    </section>
  </div>
</main>
